export default __webpack_public_path__ + "static/media/24X7RETAIL.5e52f559.png";